import { render, staticRenderFns } from "./FrrSliderArrow.vue?vue&type=template&id=334494cf&scoped=true&"
import script from "./FrrSliderArrow.vue?vue&type=script&lang=js&"
export * from "./FrrSliderArrow.vue?vue&type=script&lang=js&"
import style0 from "./FrrSliderArrow.sass?vue&type=style&index=0&id=334494cf&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334494cf",
  null
  
)

export default component.exports